import { ElementStore } from 'component/Carousel/store/ElementStore'
import { getIndexPosition, setPosition } from 'component/Carousel/util/position'

export type Apply = (value: number) => void

export type Animation = {
  from: number
  to: number
  duration: number
  apply: Apply
}

export function getAnimation(element: ElementStore, smooth: boolean): Animation {
  const from = element.position
  const to = getIndexPosition(element)
  const duration = smooth ? 200 : 0
  const apply: Apply = position => setPosition(element, position)
  return { from, to, duration, apply }
}
